import { getRole } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export const useGetRole = (roleId: string) => {
  return useQuery(['role', roleId], () => getRole(roleId), {
    enabled: !!roleId?.trim(),
  });
};
